import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const NotesBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state, dispatch } = useBuilder();
  const heading = block.settings.headingOverride || "Notes";

  return (
    <div className="py-4">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">{heading}</p>
      <textarea
        value={state.notesToClient}
        onChange={(e) => dispatch({ type: "SET_NOTES", field: "notesToClient", value: e.target.value })}
        rows={3}
        placeholder="Payment instructions, thank you notes, etc."
        className="w-full text-sm text-slate-700 bg-transparent border border-slate-200 rounded-lg px-3 py-2 focus:outline-none focus:border-emerald-600 resize-none print:border-0 print:p-0"
      />
    </div>
  );
};

export default NotesBlock;
